export default __webpack_public_path__ + "static/media/create-app-img.9be521d4.png";